import { defineStore } from "pinia";
import { commClient } from "fw4-library";
import { i18n } from "@app/i18n";
import { IFileData } from "fw4-library";
import { useAppStore } from "@appstore/store";
import router from "@/app/router";

export interface IDokoncanjePogodbe {
    PogodbaId: number;
    StPogodbe: string;
    ImePriimek: string;
    Naslov: string;
    NaslovDodatno: string;
    DatumRojstva: string;
    DavcnaSt: string;
    OsDokTip: string;
    OsDokSt: string;
    DatumIzdaje: string;
    DatumVeljavnosti: string;
    StatusPogodbe: number,
    HitraOdobritev: boolean,
    DIYType: string,
    PlacaPokojnina: number,
    Placa2: number,
    Placa3: number,
    TipZaposlitve: string,
    TipAkcije: string,
    TipDokumentacije: string;
    DisableSisbonBtn: boolean; 
    IdEntryIncorrect: boolean;
    DocumentationShow: boolean;
    SlovenianCitizen: boolean;
    SisbonCompleted: boolean;
    IsIdentified: boolean;
    EmploymentType: number;
    SlovenianEmployment: boolean;
    Pay3: boolean;
}

export interface IDokoncanjePogodbeSearch {
    Search: string;
}

export interface IDokoncanjeDokumentacije {
    DocumentNumber: string;
    Files: IFileData[];
    BindingFiles: IFileData[];
}

export interface IIdentifikacijaSisbon{
    IsIdentificationSuccessful: boolean;
    IdNumber: string;
}

export interface ISteps{
    Pogodba: {
        done: boolean;
        disabled: boolean
    };
    Dokumentacija: {
        done: boolean;
        disabled: boolean
    };
    Identifikacija: {
        done: boolean;
        disabled: boolean
    };
    Zakljucek: {
        done: boolean;
        disabled: boolean
    };
}

export interface IDokoncanjePogodbeFormState {
    Search: string;
    ErrorText: string;
    SuccessText: string;
    DocumentNumber: string;
    IsSisbonSuccess: boolean;
    // IsContractLoaded: boolean;
    IsIdentificationSuccessful: boolean;
    IsSalaryOK: boolean;
    SisbonCheckInProgress: boolean;
}

export interface IDokoncajPogodbaESignLater {
    showPodpis: boolean;
    Url: string;
}
export const dokoncanjePogodbeInitial: IDokoncanjeDokumentacije = {
    DocumentNumber: "",
    Files: [],
    BindingFiles: []
};

interface IDokoncanjePogodbeState{
    FormState: IDokoncanjePogodbeFormState;
    Pogodba: IDokoncanjePogodbe;
    DokoncajESignLater: IDokoncajPogodbaESignLater;
    DokoncanjePogodbe: IDokoncanjePogodbeSearch;
    DokoncanjeDokumentacije: IDokoncanjeDokumentacije;
    DokoncanjeIdentifikacijaSisbon: IIdentifikacijaSisbon;
    ExpandNavigation: boolean;
    Steps: ISteps;
}



export const useDokoncanjePogodbeStore = defineStore('dokoncanjePogodb', {
    state: (): IDokoncanjePogodbeState => {
        return {
            Pogodba: {
                PogodbaId: -1,
                StPogodbe: "",
                ImePriimek: "",
                Naslov: "",
                NaslovDodatno: "",
                DatumRojstva: "",
                DavcnaSt: "",
                OsDokTip: "",
                OsDokSt: "",
                DatumIzdaje: "",
                DatumVeljavnosti: "",
                StatusPogodbe: 0,
                HitraOdobritev: false,
                DIYType: "",
                PlacaPokojnina: 0,
                Placa2: 0,
                Placa3: 0,
                TipZaposlitve: "",
                TipAkcije: "",
                TipDokumentacije: "",
                DisableSisbonBtn: false,
                IdEntryIncorrect: false,
                DocumentationShow: false,
                SlovenianCitizen: true,
                SisbonCompleted: false,
                IsIdentified: false,
                EmploymentType: 0,
                SlovenianEmployment: true,
                Pay3: false
            },
            FormState: {
                Search: "",
                ErrorText: "",
                SuccessText: "",
                DocumentNumber: "",
                // IsContractLoaded: false,
                IsSisbonSuccess: false,
                SisbonCheckInProgress: false,
                IsIdentificationSuccessful: false,
                IsSalaryOK: false
            },
            DokoncajESignLater: {
                showPodpis: false,
                Url: ""
            },
            // DokoncanjePogodbe: JSON.parse(JSON.stringify(dokoncanjePogodbeInitial)),
            DokoncanjePogodbe: {
                Search: ""
            },
            DokoncanjeDokumentacije: JSON.parse(JSON.stringify(dokoncanjePogodbeInitial)),
            // DokoncanjeDokumentacije: {
            //     DocumentNumber: "",
            //     Files: [],
            //     BindingFiles: []
            // },
            DokoncanjeIdentifikacijaSisbon: {
                IsIdentificationSuccessful: false,
                IdNumber: ""
            },
            Steps: {
                Pogodba: {
                    done: false,
                    disabled: false
                },
                Dokumentacija: {
                    done: false,
                    disabled: false
                },
                Identifikacija: {
                    done: false,
                    disabled: false
                },
                Zakljucek: {
                    done: false,
                    disabled: false
                },
            },
            ExpandNavigation: true,
        }
    },
    actions: {
        async getPogodbaByNumber() {
            const getComplete = (Message: any): void => {
                this.FormState.ErrorText = "";
                if (Message.errorText == "") { 
                    this.getPogodba(Message.PogodbaId);
                    // this.FormState.IsContractLoaded = true;
                } 
                else {
                    //this.FormState.SuccessText = "Pogodba s to številko ne obstaja!";
                    this.FormState.Search = "";
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.IsSisbonSuccess = false;
                    this.FormState.ErrorText = Message.errorText;
                }
            };

            commClient.executeMethod("sf.ContractForIdentificationByNumber", {
                StPogodbe: this.FormState.Search
            }, getComplete);
        },

        async getPogodba(pogodbaId: number) {
            const getComplete = (Message: any): void => {
                this.FormState.ErrorText = "";
                if (Message.errorText == "") { 
                    this.Pogodba = Message as IDokoncanjePogodbe;
                    // this.FormState.IsContractLoaded = true;

                    if (this.Pogodba.DIYType == "POS") {
                        router.push({ name: "dokoncanje_dokumentacija" });
                    } else {
                        router.push({ name: "dokoncanje_identifikacija" });
                    }

                    // if (this.Pogodba.StatusPogodbe != 14 && this.Pogodba.StatusPogodbe != 70 && this.Pogodba.StatusPogodbe != 17 && this.Pogodba.StatusPogodbe != 1) {
                    //     // this.FormState.IsContractLoaded = false;
                    //     this.FormState.IsSisbonSuccess = true;
    
                    //     this.FormState.Search = "";
                    //     this.FormState.SuccessText = "Sisbon preverjanje je bilo že predhodno izvedeno in je bilo uspešno!";
                    //     // sign contract
                    //     this.pogodbaPodpisLater();
                    //     this.Pogodba.PogodbaId = -1;
                    // } else {
                    // }
                } 
                else {
                    alert("napaka");
                    this.FormState.SuccessText = "Napaka!";
                    this.FormState.Search = "";
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.IsSisbonSuccess = false;
                    this.FormState.ErrorText = Message.errorText;
                }
            };

            commClient.executeMethod("sf.ContractForIdentification", {
                PogodbaId: pogodbaId
            }, getComplete);
        },

        restore() {
            this.$reset();
            router.push({ name: "seznam_pogodb_home"});
        },

        async cancelContract() {
            const appStore = useAppStore();

            this.FormState.SisbonCheckInProgress = true;
            const cancelComplete = (Message: any): void => {
                if (Message.Success == 1) { 
                    this.FormState.IsSisbonSuccess = true;
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.SisbonCheckInProgress = false;
                    appStore.ShowSnackBar("Vloga uspešno preklicana, lahko jo oddate ponovno.", "success");
                    router.push({name:"seznam_pogodb_home"});
                } 
            };

            commClient.executeMethod("CancelContract", {
                PogodbaId: this.Pogodba.PogodbaId

            }, cancelComplete);
        },

        async checkSisbon() {
            //this.FormState.IsContractLoaded = !this.FormState.IsContractLoaded;
            this.FormState.SisbonCheckInProgress = true;
            const getComplete = (Message: any): void => {
                if (Message.Success == 1) { 
                    this.FormState.IsSisbonSuccess = true;
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.SisbonCheckInProgress = false;
                    this.FormState.Search = "";
                    if (Message.IsGold == true) {
                        this.FormState.SuccessText = "Stranka bo na e-mail naslov prejela informacijo o odobritvi nakupa na obroke.";
                    } else {
                        this.FormState.SuccessText = "SISBON preverjanje je bilo uspešno. ";
                    }
                    // sign contract
                    this.pogodbaPodpisLater();
                    this.Pogodba.PogodbaId = -1;
                } 
                else if (Message.Success == 2) {
                    this.FormState.Search = "";
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.IsSisbonSuccess = false;
                    this.FormState.SisbonCheckInProgress = false;
                    this.FormState.ErrorText = "Stranka v sistem SISBON še ni vpisana. Preverjanje stranke in zaključek postopka bo izvedeno naknadno s strani NLB Buy&Go. Do prejema informacije o odobritvi ali zavrnitvi NE IZDAJATE blaga.";
                    router.push({name:"dokoncanje_zakljucek"})
                }
                else if (Message.Success == 5) {
                    this.FormState.Search = "";
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.IsSisbonSuccess = false;
                    this.FormState.SisbonCheckInProgress = false;
                    this.FormState.ErrorText = "Ne moremo preveriti stranke v sistemu SISBON, ker nimate ustreznega Sisbon pooblastila. Preverjanje stranke in zaključek postopka bo izvedeno naknadno s strani NLB Buy&Go. Do prejema informacije o odobritvi ali zavrnitvi NE IZDAJATE blaga.";
                    router.push({name:"dokoncanje_zakljucek"})
                }
                else {
                    this.FormState.Search = "";
                    // this.FormState.IsContractLoaded = false;
                    this.FormState.IsSisbonSuccess = false;
                    this.FormState.SisbonCheckInProgress = false;
                    if (Message.IsGold == true) {
                        this.FormState.ErrorText = "Stranka bo na e-mail naslov prejela informacijo o odobritvi nakupa na obroke.";
                    } else {
                        this.FormState.ErrorText = i18n.global.t("Contract.SisbonDeny");
                    }
                    router.push({name:"dokoncanje_zakljucek"})
                }
            };

            let uploadFiles: string = "";
            if (this.DokoncanjeDokumentacije.Files.length > 0) {
                uploadFiles = this.DokoncanjeDokumentacije.Files.map((files: { FileId: string }) => files.FileId).join(";")
            }
            if (this.DokoncanjeDokumentacije.BindingFiles.length > 0) {
                if (uploadFiles.length > 0) {
                    uploadFiles += ";";
                }
                uploadFiles += this.DokoncanjeDokumentacije.BindingFiles.map((files: { FileId: string }) => files.FileId).join(";")
            }

            commClient.executeMethod("CheckSisbonWeb", {
                PogodbaId: this.Pogodba.PogodbaId,
                // Datoteke: this.FormState.Dokumentacija.Files.map((files: { FileId: string }) => files.FileId).join(";")
                Datoteke: uploadFiles

            }, getComplete);
        },

        async pogodbaPodpisLater() {
            const uploadPogodbaCompleteLater = (Message: any): void => {
                if (Message) {  
                    if(Message.Success){
                        console.log("setting url");
                        this.DokoncajESignLater.Url = Message.Url;
                    }
                    else{
                        alert("Napaka pri prenosu dokumentov.");
                    }
                }
                else {
                }
            }
            this.DokoncajESignLater.showPodpis = true;
            this.DokoncajESignLater.Url = "/StaticLoaders/upload_wait.html";

            commClient.OnStreamDataReceived.ClearCallbacks();
            commClient.OnStreamDataReceived.AddCallback(this.signComplete);

            
            commClient.executeMethod("ContractESignLater", { 
                //PogodbaId: 140620,
                PogodbaId: this.Pogodba.PogodbaId
            }, uploadPogodbaCompleteLater);
        },

        signComplete(Message: any){
            if(Message && Message[0] && Message[0].Success){
                if (Message[0].Status == "complete") {
                    this.DokoncajESignLater.showPodpis = false;
                    this.DokoncajESignLater.Url = "";
                    router.push({name:"dokoncanje_zakljucek"})
                    // reload?
                }
            }  else {
                //alert("Napaka pri podpisu.");
            }

            commClient.OnStreamDataReceived.RemoveCallback(this.signComplete);
        },

        closeDokoncanjePogodbe(){
            router.push({name: "pogodbe_seznam"});
        },
    },

    getters: {
        placa1Formatted: (state) => {
            return i18n.global.n(state.Pogodba.PlacaPokojnina, 'decimal') + " €"
        },
        placa2Formatted: (state) => {
            return i18n.global.n(state.Pogodba.Placa2, 'decimal') + " €"
        },
        placa3Formatted: (state) => {
            return i18n.global.n(state.Pogodba.Placa3, 'decimal') + " €"
        },
    }
});